'use strict';

var int = require('../int.cjs');
var index = require('../numbers/index.cjs');
var units = require('../numbers/units.cjs');
var transform = require('./transform.cjs');

const numberValueTypes = {
    // Border props
    borderWidth: units.px,
    borderTopWidth: units.px,
    borderRightWidth: units.px,
    borderBottomWidth: units.px,
    borderLeftWidth: units.px,
    borderRadius: units.px,
    radius: units.px,
    borderTopLeftRadius: units.px,
    borderTopRightRadius: units.px,
    borderBottomRightRadius: units.px,
    borderBottomLeftRadius: units.px,
    // Positioning props
    width: units.px,
    maxWidth: units.px,
    height: units.px,
    maxHeight: units.px,
    top: units.px,
    right: units.px,
    bottom: units.px,
    left: units.px,
    // Spacing props
    padding: units.px,
    paddingTop: units.px,
    paddingRight: units.px,
    paddingBottom: units.px,
    paddingLeft: units.px,
    margin: units.px,
    marginTop: units.px,
    marginRight: units.px,
    marginBottom: units.px,
    marginLeft: units.px,
    // Misc
    backgroundPositionX: units.px,
    backgroundPositionY: units.px,
    ...transform.transformValueTypes,
    zIndex: int.int,
    // SVG
    fillOpacity: index.alpha,
    strokeOpacity: index.alpha,
    numOctaves: int.int,
};

exports.numberValueTypes = numberValueTypes;
//# sourceMappingURL=number.cjs.map
